module.exports = __webpack_public_path__ + "static/why-i-chose-cal-state-fullerton-menu-d117460bbd96de011d853edb43ee626e.jpg";